import React,{createContext, useEffect, useState} from "react";
import { BASE_URL } from "../Utils/URLs";
import { rewriteLocalPathsInData } from "../Utils/mediaUrl";

export const UserContext = createContext()

 export const UserProvider = ({children})=>{
    const [user,setUser] = useState(null)
    const [notificcations,setNotifications] = useState([])
    const [notificationRes, setnotificationRes] = useState({})
    const [ws, setWs] = useState(null); 
    const [passwordStatus,setPasswordStatus] = useState("")
    const [value, setValue] = React.useState(0);
    const storedUser = localStorage.getItem("user")
   
   

useEffect(()=>{
   
    if(storedUser){
      const parsedData  = JSON.parse(storedUser)
      console.log("storedUser",parsedData)
        setUser(rewriteLocalPathsInData(parsedData))
    }
},[storedUser])


const LoginUser = (userData)=>{
const rewritten = rewriteLocalPathsInData(userData)
setUser(rewritten)
localStorage.setItem("user",JSON.stringify(rewritten))
}

const LogoutUser = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('role')
  };

  const UpdateUser = (data)=>{
    const rewritten = rewriteLocalPathsInData(data)
    setUser(rewritten)
    const storedUser = JSON.parse( localStorage.getItem("user"))
    const newData = {...storedUser,isSubmit:1}
    localStorage.setItem("user",JSON.stringify(rewritten))
  }
  useEffect(() => {
    if (!user?._id) return;

    let socket = null;
    let reconnectTimeout = null;
    let isConnecting = false;
    let shouldReconnect = true;
    let attemptIndex = 0;

    const getWsCandidates = () => {
      try {
        const u = new URL(String(BASE_URL || window.location.origin));
        // Prefer page protocol to avoid mixed-content on https pages
        const wsProto = window.location.protocol === "https:" ? "wss:" : "ws:";
        const pageHost = window.location.host;
        const apiHost = u.host;
        const basePath = String(u.pathname || "").replace(/\/+$/, ""); // e.g. "/api_new" or "/api"

        const qs = `?userId=${encodeURIComponent(user._id)}`;
        // If app runs on one host but API on another (e.g. localhost:3000 vs localhost:5000),
        // prefer the API host to avoid noisy failed attempts.
        const hosts = apiHost && apiHost !== pageHost
          ? [apiHost]
          : Array.from(new Set([pageHost, apiHost].filter(Boolean)));
        const candidates = [];
        const addForHost = (h) => {
          const base = `${wsProto}//${h}`;
          const add = (path) => candidates.push(`${base}${path}${qs}`);
          // Production mounts API under /api_new/*.
          // If basePath exists, prioritize it (avoid noisy root candidates that may be refused).
          if (basePath) {
            add(`${basePath}`);      // /api_new?userId=...
            add(`${basePath}/`);     // /api_new/?userId=...
            add(`${basePath}/api`);  // /api_new/api?userId=...
            add(`${basePath}/api/`); // /api_new/api/?userId=...
            add(`/api_new`);
            add(`/api_new/`);
            add(`/api_new/api`);
            add(`/api_new/api/`);
            return;
          }
          // Local/other deployments
          add(`/`);      // /?userId=...
          add(`/api`);   // /api?userId=...
          add(`/api/`);
        };
        hosts.forEach(addForHost);
        return Array.from(new Set(candidates));
      } catch (_) {
        const wsProto = window.location.protocol === "https:" ? "wss:" : "ws:";
        const host = window.location.host;
        const qs = `?userId=${encodeURIComponent(user._id)}`;
        return [
          `${wsProto}//${host}/api_new${qs}`,
          `${wsProto}//${host}/api_new/api${qs}`,
          `${wsProto}//${host}/api${qs}`,
          `${wsProto}//${host}/?userId=${encodeURIComponent(user._id)}`
        ];
      }
    };

    const connectWebSocket = () => {
      if (isConnecting || socket?.readyState === WebSocket.OPEN) return;
      
      isConnecting = true;
      
      try {
        const candidates = getWsCandidates();
        const wsUrl = candidates[attemptIndex % candidates.length];
        attemptIndex += 1;
        socket = new WebSocket(wsUrl);
       
        socket.onopen = () => {
          isConnecting = false;
          setWs(socket);
        };
    
        socket.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);    
            setNotifications(prevNotifications => {
              const nid = data?.data?._id || data?.data?.id || data?._id || data?.id;
              const existingNotification = nid ? prevNotifications.find(notification => notification._id === nid) : null;
              if(!existingNotification){
                showBrowserNotification(data?.message || data?.data?.message || "New notification");
                return [ {
                  _id: nid || `ws_${Date.now()}`,
                  name: data?.data?.name,
                  message: data?.message || data?.data?.message,
                  route: data?.route || data?.data?.route,
                  created_at: data?.data?.created_at || new Date().toISOString(),
                  status: "unread"
                }, ...prevNotifications];
              }else{
                return prevNotifications
              }
            });
          } catch (error) {
            console.error('Error parsing WebSocket message:', error);
          }
        };
        
        socket.onclose = (event) => {
          isConnecting = false;
          setWs(null);
          
          // Only reconnect if tab is visible and should reconnect
          if (shouldReconnect && !document.hidden) {
            reconnectTimeout = setTimeout(connectWebSocket, 2000);
          }
        };
    
        socket.onerror = (error) => {
          isConnecting = false;
          setWs(null);
          console.error('WebSocket error:', error);
          
          // Only reconnect if tab is visible and should reconnect
          if (shouldReconnect && !document.hidden) {
            reconnectTimeout = setTimeout(connectWebSocket, 2000);
          }
        };
      } catch (error) {
        isConnecting = false;
        console.error('Error creating WebSocket:', error);
        if (shouldReconnect && !document.hidden) {
          reconnectTimeout = setTimeout(connectWebSocket, 2000);
        }
      }
    };

    // Handle tab visibility changes
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Tab is hidden - pause reconnection attempts
        shouldReconnect = false;
        if (reconnectTimeout) {
          clearTimeout(reconnectTimeout);
          reconnectTimeout = null;
        }
      } else {
        // Tab is visible - resume connection if needed
        shouldReconnect = true;
        if (!socket || socket.readyState === WebSocket.CLOSED || socket.readyState === WebSocket.CLOSING) {
          connectWebSocket();
        }
      }
    };

    // Initial connection
    connectWebSocket();

    // Listen for tab visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup function
    return () => {
      shouldReconnect = false;
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (socket) {
        socket.onclose = null; // Prevent reconnection on cleanup
        socket.onerror = null;
        if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
          socket.close();
        }
        setWs(null);
      }
    };
  }, [user?._id]);

  const showBrowserNotification = (message) => {
    if ("Notification" in window) {
      if (Notification.permission === 'granted') {
        new Notification('New Notification', {
          body: message,
        });
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            new Notification('New Notification', {
              body: message,
            });
          }
        });
      }
    }
  };


  function checkPasswordStrength(password) {
    let strength = 0;
    if (password.length >= 8) strength += 1;
    if (/\d/.test(password)) strength += 1;
    if (/[A-Z]/.test(password)) strength += 1;
    if (/[a-z]/.test(password)) strength += 1;
    if (/[\W_]/.test(password)) strength += 1;
    if (strength <= 2) {
        setPasswordStatus("Weak");
    } else if (strength === 3) {
        setPasswordStatus("Good");
    } else if (strength >= 4) {
        setPasswordStatus("Strong");
    }
}



  return (
    <UserContext.Provider value={{ user, LoginUser, LogoutUser,setUser,UpdateUser,notificcations,setNotifications,notificationRes, setnotificationRes,checkPasswordStrength,passwordStatus,value,setValue,ws }}>
      {children}
    </UserContext.Provider>
  );

}
